import type { ReactNode } from 'react';
import type { NotificationData } from '@mantine/notifications';
import { notifications } from '@mantine/notifications';
import { FiAlertCircle, FiAlertTriangle, FiCheckCircle, FiInfo } from 'react-icons/fi';

import type { LockedProps } from '../types';

export type NotificationProps = Omit<NotificationData, 'message' | LockedProps> & {
  message?: ReactNode | undefined;
};

// Semantic-intent helpers: each picks the color, the icon and the dismiss labels. All
// appearance lives in the theme's Notification entry (tools/theme/src/notification.module.css).

export function showNotification(params: NotificationProps) {
  notifications.show({
    ...params,
    closeButtonProps: { 'aria-label': 'Dismiss Notification', title: 'Dismiss Notification' },
    color: 'primary',
    icon: params.icon ?? <FiAlertCircle />,
    message: params.message ?? '',
  });
}

export function showInfoNotification(params: NotificationProps) {
  notifications.show({
    ...params,
    closeButtonProps: { 'aria-label': 'Dismiss Notification', title: 'Dismiss Notification' },
    color: 'blue',
    icon: params.icon ?? <FiInfo />,
    message: params.message ?? '',
  });
}

export function showWarningNotification(params: NotificationProps) {
  notifications.show({
    ...params,
    closeButtonProps: { 'aria-label': 'Dismiss Notification', title: 'Dismiss Notification' },
    color: 'yellow',
    icon: params.icon ?? <FiAlertTriangle />,
    message: params.message ?? '',
  });
}

export function showSuccessNotification(params: NotificationProps) {
  notifications.show({
    ...params,
    closeButtonProps: { 'aria-label': 'Dismiss Notification', title: 'Dismiss Notification' },
    color: 'green',
    icon: params.icon ?? <FiCheckCircle />,
    message: params.message ?? '',
  });
}

export function showErrorNotification(params: NotificationProps) {
  notifications.show({
    ...params,
    closeButtonProps: { 'aria-label': 'Dismiss Notification', title: 'Dismiss Notification' },
    color: 'red',
    icon: params.icon ?? <FiAlertTriangle />,
    message: params.message ?? '',
  });
}
